import { type PhoneType } from "./is-valid-phone";

export const DEFAULT_ACCEPT: PhoneType[] = ["mobile", "landline"];
